const { useState } = require("react");
const { createAPI } = require("services/api/api");

export const useQuickCraftLogic = () => {
  const api = createAPI();
  const [identityName, setIdentityName] = useState("");
  const [data, setData] = useState([]);
  const [step, setStep] = useState("start");
  const [isLoading, setIsLoading] = useState(true);
  const [choosedOptions, setChoosedOptions] = useState([
    { label: "category", category_collection: "", category_rarity: "" },
    { label: "month", month_collection: "", month_rarity: "" },
    { label: "day", day_collection: "", day_rarity: "" },
    { label: "year", year_collection: "", year_rarity: "" },
  ]);

  const fetchData = (shortcutData) => {
    setIsLoading(true);

    api
      .get(
        `/me/matches/params?celebrity_id=${shortcutData[0]}&in_slot=${shortcutData[1]}&card_id=${shortcutData[2]}`
      )
      .then((response) => {
        const dataArray = Object.entries(response.data).map(([key, value]) => ({
          label: key,
          ...value,
        }));

        const sortOrder = ["category", "month", "day", "year"];
        dataArray.sort((a, b) => sortOrder.indexOf(a.label) - sortOrder.indexOf(b.label));

        setData(dataArray);
        setIdentityName(shortcutData[3]);

        setChoosedOptions((prevOptions) =>
          prevOptions.map((option) => {
            const matchingData = dataArray.find((item) => item.label === option.label);
            return {
              ...option,
              [`${option.label}_collection`]: matchingData.card_collections[0],
              [`${option.label}_rarity`]: matchingData.rarities[0],
            };
          })
        );
      })
      .catch((e) => {
        console.error("Error fetching quick craft data:", e);
        setStep("fail");
      })
      .finally(() => setIsLoading(false));
  };

  return { identityName, data, step, isLoading, setIsLoading, choosedOptions, setChoosedOptions, fetchData, setStep };
};
